import classNames from 'classnames';
import React, { FC, memo } from 'react';
import { Outlet } from 'react-router-dom';
import { SpecialPromotionOpener, useSpecialPromotionModal } from 'features/SpecialPromotion';
import { useScreenBreakpoints } from 'shared/utils/hooks/useScreenBreakpoints';
import { CustomerHeader } from 'widgets/CustomerHeader';

export const CustomerLayout: FC = memo(() => {
  const { showSpecialPromotion } = useSpecialPromotionModal();

  const { isDesktop } = useScreenBreakpoints();
  const marginAmount = isDesktop ? 'mt-16' : 'mt-24';

  return (
    <div
      className={classNames('min-h-screen px-0 desktop:px-[50px] py-0 desktop:py-[25px] bg-backgroundColor', {
        [marginAmount]: showSpecialPromotion,
      })}
    >
      <CustomerHeader />
      <div className="max-w-[1200px] mx-auto">
        <SpecialPromotionOpener eventTheme="easter" />
        <main className="desktop:pb-4 pb-16">
          <Outlet />
        </main>
      </div>
    </div>
  );
});
